export const escrowTableSize = '5fr 1fr 240px';
